import { render, staticRenderFns } from "./MTab.vue?vue&type=template&id=34563f47&"
import script from "./MTab.vue?vue&type=script&lang=ts&"
export * from "./MTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports